module.exports = __webpack_public_path__ + "static/img/website-logo.73f6a753.jpg";